import { DateHelper } from "../../helper/date-helper";

type ValidationCallback = DevExpress.ui.CustomRule["validationCallback"];
type DateLike = Date | string | number | (() => DateLike) | { value: DateLike };

export class ValidationFunctions {
	public static dateRangeStart(rangeEnd: DateLike): ValidationCallback {
		return (options) => this.dateRange(options.value, rangeEnd);
	}

	public static dateRangeEnd(rangeStart: DateLike): ValidationCallback {
		return (options) => this.dateRange(rangeStart, options.value);
	}

	public static regex(regex: RegExp): ValidationCallback {
		return (options) => {
			let value = String(options.value == null ? "" : options.value);
			return Boolean(value.match(regex));
		};
	}

	public static dateRange(rangeStart: DateLike, rangeEnd: DateLike) {
		let start = this.getDateWithoutTime(rangeStart);
		let end = this.getDateWithoutTime(rangeEnd);
		return !start || !end || start <= end;
	}

	private static getDateWithoutTime(dateLike: DateLike): Date {
		while (!(dateLike instanceof Date)) {
			if (dateLike == null) {
				return null;
			}

			switch (typeof dateLike) {
				case "function":
					dateLike = dateLike();
					break;

				case "string":
				case "number":
					dateLike = new Date(dateLike);
					break;

				case "object":
					if ("value" in dateLike) {
						dateLike = dateLike.value;
					} else {
						return null;
					}
					break;

				default:
					return null;
			}
		}

		return isNaN(dateLike.getTime()) ? null : DateHelper.getDateWithoutTime(dateLike);
	}
}

(window as any).validator = ValidationFunctions;